export enum HTTP_STATUS_CODE {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403
}
